module.exports = __webpack_public_path__ + "img/jpg-erweima-02@3x.f0f1e906.png";